import { isEmpty } from "./utils";
import generateUploadURL from "../network/api_calls/generateUploadURL";

const uploadToS3 = async ({ file, onSuccess, onFailure, onProgress }) => {
  generateUploadURL({
    data: {
      // ALLOWED_UPLOAD_SIZE_KB is in KB (1024 bytes), not "thousands of bytes" —
      // dividing by 1000 overstated the size and could reject valid near-limit files.
      content_length: file.size / 1024,
      filename: file.name,
    },
    onSuccess: (response) => {
      const { data = "" } = response || {};
      const { data: uploadData, serverFileName } = data;

      if (isEmpty(data)) {
        onFailure("Something went wrong. Please try again later!", file.name);
      } else {
        upload_image({
          file,
          data: { data: uploadData, serverFileName },
          onSuccess,
          onFailure,
          onProgress,
        });
      }
    },
    onFailure: (error) => {
      onFailure(error, file.name);
    },
  });
};

const upload_image = ({ file, data, onSuccess, onFailure, onProgress }) => {
  const { data: uploadData, serverFileName } = data || {};
  const { url, fields } = uploadData || {};

  const formData = new FormData();
  Object.entries(fields).forEach(([k, v]) => {
    formData.append(k, v);
  });
  formData.append("file", file);

  const xhr = new XMLHttpRequest();
  xhr.open("POST", url, true);

  xhr.upload.onprogress = (event) => {
    if (event.lengthComputable) {
      const progress = Math.round((event.loaded / event.total) * 100);
      onProgress(progress); // update loader UI
    }
  };

  // Success
  xhr.onload = () => {
    if (xhr.status === 204 || xhr.status === 200) {
      onSuccess({
        filename: file.name,
        // serverFileName from the backend response, NOT fields.key: the S3 field
        // is the full folder-prefixed object key (e.g. "stg/ABC1234.apk"), and
        // storing that double-prefixes every later download/delete request.
        serverFileName,
        url,
      });
    } else {
      onFailure("Upload failed!");
    }
  };

  // Error
  xhr.onerror = () => onFailure("Upload failed!");

  xhr.send(formData);
};

const deleteFromS3 = ({ file, onComplete }) => {};

export { uploadToS3, deleteFromS3 };
